<template>
  <layout :showuserinfo="false" title="Manual Pengguna" :crumbs="crumbs">
    <z-page
        :append-button="true"
        icon="fal fa-paper-plane"
        :title="'Senarai Manual Pengguna'"
        >
        <table class="table-dashboard" width="100%">
          <thead>
            <tr>
              <td style="text-align: left">Bil.</td>
              <td style="text-align: left">Keterangan</td>
              <td style="text-align: center">Dokumen</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Manual Dashboard</td>
              <td style="text-align: center; color: green">
                <a href="User Manual/iHasil UM - Dashboard V1.0.pdf" target="_blank"
                  ><i class="fal fa-file-alt mr2" style="font-size: 15px"></i
                ></a>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>Manual Bil Pelbagai</td>
              <td style="text-align: center; color: green">
                <a href="User Manual/iHasil UM - Modul Bil Pelbagai V2.0.pdf" target="_blank"
                  ><i class="fal fa-file-alt mr2" style="font-size: 15px"></i
                ></a>
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td>Manual Kutipan</td>
              <td style="text-align: center; color: green">
                <a href="User Manual/iHasil UM - Modul Kutipan V2.0.pdf" target="_blank"
                  ><i class="fal fa-file-alt mr2" style="font-size: 15px"></i
                ></a>
              </td>
            </tr>
            <tr>
              <td>4</td>
              <td>Manual Deposit</td>
              <td style="text-align: center; color: green">
                <a href="User Manual/iHasil UM - Modul Deposit V2.0-3.pdf" target="_blank"
                  ><i class="fal fa-file-alt mr2" style="font-size: 15px"></i
                ></a>
              </td>
            </tr>
            <tr>
              <td>5</td>
              <td>Manual Bayaran</td>
              <td style="text-align: center; color: green">
                <a href="User Manual/iHasil UM - Bayaran V2.0-1.pdf" target="_blank"
                  ><i class="fal fa-file-alt mr2" style="font-size: 15px"></i
                ></a>
              </td>
            </tr>
            <tr>
              <td>6</td>
              <td>Manual Cukai Tanah</td>
              <td style="text-align: center; color: green">
                <a href="User Manual/iHasil UM - Cukai Tanah V1.0.pdf" target="_blank"
                  ><i class="fal fa-file-alt mr2" style="font-size: 15px"></i
                ></a>
              </td>
            </tr>
            <tr>
              <td>7</td>
              <td>Manual Penguatkuasaan</td>
              <td style="text-align: center; color: green">
                <a href="User Manual/iHasil UM - Modul Penguatkuasaan  V1.0.pdf" target="_blank"
                  ><i class="fal fa-file-alt mr2" style="font-size: 15px"></i
                ></a>
              </td>
            </tr>
            <tr>
              <td>8</td>
              <td>Manual Tunggakan Hasil</td>
              <td style="text-align: center; color: green">
                <a href="User Manual/iHasil UM - Modul Tunggakan Hasil V1.0.pdf" target="_blank"
                  ><i class="fal fa-file-alt mr2" style="font-size: 15px"></i
                ></a>
              </td>
            </tr>
            <tr>
              <td>9</td>
              <td>Manual Utiliti</td>
              <td style="text-align: center; color: green">
                <a href="User Manual/iHasil UM - Modul Utiliti V1.0.pdf" target="_blank"
                  ><i class="fal fa-file-alt mr2" style="font-size: 15px"></i
                ></a>
              </td>
            </tr>
            <tr>
              <td>10</td>
              <td>Manual Cek Tak Laku</td>
              <td style="text-align: center; color: green">
                <a href="User Manual/iHasil UM - Modul Cek Tak Laku V2.0.pdf" target="_blank"
                  ><i class="fal fa-file-alt mr2" style="font-size: 15px"></i
                ></a>
              </td>
            </tr>
            <tr>
              <td>11</td>
              <td>Manual Pelarasan Jurnal</td>
              <td style="text-align: center; color: green">
                <a href="User Manual/iHasil UM - Modul Pelarasan Jurnal V2.0.pdf" target="_blank"
                  ><i class="fal fa-file-alt mr2" style="font-size: 15px"></i
                ></a>
              </td>
            </tr>
          </tbody>
        </table>
    </z-page>
  </layout>
</template>
  <script>
import ZResource from "@/Modules/z-resource";
import { Inertia } from "@inertiajs/inertia";
import WaveUI from "wave-ui";
import moment from "moment";
import Table from "./Component/Table.vue";
export default {
  extends: ZResource,
  data() {
    return {
        crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Dokumen', route: '' },
        { label: 'Panduan Pengguna', route: '/manualPengguna' },
      ],
    };
  },
  methods: {},
  created: function () {},
  mounted() {},
  components: { Table },
};
</script>
